var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgForword = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m20.4 12-8.202-8.202L10.996 5l7 7-7 7 1.202 1.202z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.4 12 4.198 3.798 2.996 5l7 7-7 7 1.202 1.202z"
})));
export { SvgForword as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwLjQwMDMgMTEuOTk5OUwxMi4xOTgyIDMuNzk3ODVMMTAuOTk2MSA0Ljk5OTkzTDE3Ljk5NjEgMTEuOTk5OUwxMC45OTYxIDE4Ljk5OTlMMTIuMTk4MiAyMC4yMDJMMjAuNDAwMyAxMS45OTk5WiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxwYXRoIGQ9Ik0xMi40MDAzIDExLjk5OTlMNC4xOTgxNyAzLjc5Nzg1TDIuOTk2MDkgNC45OTk5M0w5Ljk5NjA5IDExLjk5OTlMMi45OTYwOSAxOC45OTk5TDQuMTk4MTcgMjAuMjAyTDEyLjQwMDMgMTEuOTk5OVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";